import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import { IAuditForcedCheckOut } from './IAuditForcedCheckOut'

export class AuditForcedCheckOut extends Entity<IAuditForcedCheckOut> {
  checkInSessionId: number
  @Type(() => User)
  user?: User

  public static new(payload: unknown): AuditForcedCheckOut {
    return plainToInstance(AuditForcedCheckOut, payload)
  }
}
